import React from "react";

interface ModalPropsI {
    children?: React.ReactNode;
    className?: string;
    showModal: boolean;
    onClose : ()=>void;
}

const Modal = ({ children, className, showModal, onClose }: ModalPropsI) => {
    const clickOutsideHandler = (e: any)=>{
        onClose()
    }

    return (
        <>
        {
            showModal ?
                <div role="dialog" className="modal-container" onClick={clickOutsideHandler}>
                    <div className={`modal ${className}`} onClick={(e)=>e.stopPropagation()}>
                        {children}
                    </div>
                </div>
                : <></>
        }
        </>
    )
}
export default Modal;